import styled from '@emotion/styled';
import { Typography } from 'antd';
import { TextProps } from 'antd/lib/typography/Text';
import React from 'react';

export interface ITextPropsProps extends TextProps {}

const Text: React.FC<ITextPropsProps> = ({ ...props }) => {
  return <Typography.Text {...props} />;
};

export default styled(Text)``;
